import * as t from 'io-ts';

import {RAsyncStatus} from '../../../appTypes';
import {RPanelCancelTokenId} from '../../panelCancelTokenId';
import {PanelTypesEnum, RContactsManagerPanelId, RPanelStateBase} from '../../panelStateBase';
import {ContactsManagerFileState, RContactsManagerFileState} from './file/contactsManagerFileState';
import {RContactsManagerParameters} from './parameters/contactsManagerParameters';
import {RContactsManagerSearchState} from './search/contactsManagerSearchState';
import {RContactsManagerSidePanelState} from './sidePanel/contactsManagerSidePanelState';
import {RContactsManagerTableState} from './table/contactsManagerTableState';

/*
 * Runtime types.
 */

export const RContactsManagerPanelState = t.intersection([
  RPanelStateBase,
  t.type({
    id: RContactsManagerPanelId,
    type: t.literal(PanelTypesEnum.CONTACTS_MANAGER),
    status: RAsyncStatus,
    cancelTokenId: RPanelCancelTokenId,
    parameters: RContactsManagerParameters,

    // Sub-state for the current table in view
    tableState: t.union([RContactsManagerTableState, t.undefined]),
    // Sub-state for side panel
    sidePanelState: t.union([RContactsManagerSidePanelState, t.undefined]),
    // Sub-state for file processing in the contacts manager
    fileState: t.union([RContactsManagerFileState, t.undefined]),
  }),
  t.partial({
    // Sub-state for the search page.
    searchState: RContactsManagerSearchState,
  }),
]);

/*
 * Types.
 */

export interface ContactsManagerPanelState extends Readonly<t.TypeOf<typeof RContactsManagerPanelState>> {
  fileState: ContactsManagerFileState | undefined;
}
